module.exports = __webpack_public_path__ + "img/brand-26.82696bfb.png";